function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.964 16V8h2.209l.293-2.758H4.964l.004-1.38c0-.72.068-1.105 1.101-1.105H7.45V0H5.24C2.588 0 1.654 1.338 1.654 3.587v1.655H0V8h1.654V16h3.31z",
  fill: "currentColor"
});

var SvgFacebook = function SvgFacebook(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 8 16",
    fill: "none"
  }, props), _ref);
};

export default SvgFacebook;